import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl'
import cx from 'classnames';
import * as List from '@/shared/ui/List';
import { Settings } from 'lucide-react';
import * as Menubar from '@radix-ui/react-menubar';
import Box from '@/shared/ui/Box';
import { getSettingsLink } from '@/shared/constants/links';
import { useNavigation } from '@/processes/Router';
import Button from '@/shared/ui/Button';
import s from './DashboardActionsDesktop.module.scss';

type DashboardActionsDesktopProps = {
  className?: string;
}

const DashboardActionsDesktop = (props: DashboardActionsDesktopProps) => {
  const { 
    className = '',
  } = props;
  const intl = useIntl();
  const [isOpen, setIsOpen] = useState(false);
  const { coin, navigate, query } = useNavigation();

  const handleToggleMenu = () => { setIsOpen(!isOpen); }

  const dashboardLinks = [
    {
      id: 'payout',
      title: 'header.payout',
      link: getSettingsLink(coin, 'payout', query),
    },
    {
      id: 'watchers',
      title: 'header.watchers',
      link: getSettingsLink(coin, 'watchers', query),
    },
  ];

  const handleLinkClick = (link: string) => {
    navigate(link);
    setIsOpen(false);
  }

  return (
    <Menubar.Root>
      <Menubar.Menu>
        <Menubar.Trigger asChild>
          {/* <button
            type="button"
            className={cx(className, s.toggler)}
            onClick={handleToggleMenu}
            aria-expanded={isOpen}
            aria-controls="dashboard-actions-menu"
          >
            <IconSettings className="w-5 sm:mr-2"/>
            <FormattedMessage id="header.actions"/>              
          </button> */}
          <Button 
            fw="normal"
            colorSchema="secondary" 
            justify="between"
            type="button"
            aria-label={intl.formatMessage({ id: 'header.actions' })}
            className={cx(s.toggler, className)}
            onClick={handleToggleMenu}
            aria-expanded={isOpen}
            aria-controls="dashboard-actions-menu"
          >
            <Settings className="size-4"/>
          </Button>
        </Menubar.Trigger>
        <Menubar.Portal>
          <Menubar.Content 
            forceMount={true}
            sideOffset={15}
            asChild
            align="start"
          >
            <Box size="none" className="min-w-[200px] z-100">
              <List.Root className={s.navList}>
                {dashboardLinks.map(({ id, title, link }) => {
                  return (
                    <Menubar.Item key={id} asChild>
                      <List.Item mb="xs" theme='secondary' className='' onClick={() => handleLinkClick(link)}>
                        <FormattedMessage id={title}/>
                      </List.Item>
                    </Menubar.Item>
                  )
                })}
              </List.Root>
            </Box>
          </Menubar.Content>
        </Menubar.Portal>
      </Menubar.Menu>
    </Menubar.Root>
  );
}

export default DashboardActionsDesktop;

